import apiRequest from './apiRequest';

export interface StripeTransaction {
  date: string;
  description: string;
  amount: number;
  amountString: string;
  currency: string;
  url: string | null;
}

export async function getStripeInvoices(stripeCustomerID: string) {
  return apiRequest<{ data: StripeTransaction[] }>(
    'user',
    `/stripe/invoices/${stripeCustomerID}`,
  );
}
